export default __webpack_public_path__ + "static/media/coin-clatter.0bcc690b.svg";